/*eslint-disable */

import { bus } from '@/main';
import toast from '@/services/toast';

export default {
  name: 'delete-data-popup',
  components: {},
  props: ['deleteDataID'],
  data () {
    return {
      isSubmitted:false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    closeRemoveItemModalFun(){
      bus.$emit('deletePopupStateBus', false)
      document.body.classList.remove('body_right_scroll_remove')
    },
    confirmDataDeleteMethod(){
      this.isSubmitted = true
      this.$store.dispatch("dataDeleteByIdAction", {id:this.deleteDataID}).then((res) => {
        this.isSubmitted = false
        toast.success("Data deleted successfully");
        this.closeRemoveItemModalFun();
      }).catch((err) => {
        toast.error(err.data.user_msg || err.data.msg || "Data is already deleted");
        this.isSubmitted = false
      })
    }
  }
}